<template>
    <div>
        <md-sidenav class="md-left collaboratorsNav" ref="collaboratorsNav">
            <md-toolbar class="md-dense main-toolbar">
                <md-button class="md-icon-button" @click="back()">
                    <md-icon>menu</md-icon>
                </md-button>
                <h3 class="md-title">Collaborators</h3>
            </md-toolbar>
            <md-list class="md-double-line">
                <md-subheader>Current Collaborators</md-subheader>
                <md-list-item v-if="owner">
                    <md-avatar>
                        <img :src="owner.profile_picture" alt="People" v-if="owner.profile_picture" />
                        <img :src="require('../../assets/img/silhouette.jpg')" v-else alt="People" />
                    </md-avatar>
                    <div class="md-list-text-container collaborator-text-container">
                        <span><strong>{{owner.username}}</strong></span>
                        <span>Project Owner</span>
                        <span>{{owner.email}}</span>
                    </div>
                </md-list-item>
                <collaborator v-for="collab in collaborators"
                    :user="user"
                    :collabUser="userByUID(collab.uid)"
                    :collaborator="collab"
                    :editable="user.uid === owner.uid"
                    :layers="layers"
                    :key="collab.id" 
                    @removeCollaborator="removeCollaborator" 
                />
            </md-list>
            <md-list class="md-double-line pendingCollaboratorList">
                <md-subheader>Pending Collaborators</md-subheader>
                <pendingCollaborator v-for="collab in pendingCollaborators"
                    :collaborator="collab"
                    :editable="user.uid === owner.uid"
                    :key="collab.id" 
                    @removePendingCollaborator="removePendingCollaborator" 
                />
            </md-list>
            <md-list>
                
                <invite v-if="canEdit" :project="project" @addCollaborator="addCollaborator"/></invite>
            </md-list>
        </md-sidenav>
    </div>
</template>

<script>
// import firebase from 'firebase';
import { mapGetters } from 'vuex';

import NavBus from '@/buses/nav';
import CollaboratorsCollaborator from '@/components/collaborators/collaborator';
import CollaboratorsPendingCollaborator from '@/components/collaborators/pending-collaborator';
import CollaboratorsInvite from '@/components/collaborators/invite';

const CollaboratorsNav = {
    name: 'CollaboratorsNav',
    props: ['project', 'user'],
    data: function() {
        return {
            collaborator: null,
            editingCollaborator: false
        };
    },
    computed: {
        ...mapGetters([
            'collaborators',
            'collaboratorByUID',
            'pendingCollaborators',
            'userByUID',
            'layers',
            'ownerUID'
        ]),
        owner() {
            return this.userByUID(this.ownerUID);
        },
        canEdit() {
            return this.collaboratorByUID(this.user.uid) || this.ownerUID === this.user.uid;
        }
    },
    methods: {
        back() {
            this.$refs.collaboratorsNav.close();
            NavBus.$emit('main-nav.open');
        },
        doneEditing() {
            this.$refs.collaboratorEdit.close();
            this.$refs.collaboratorsNav.open();
            this.collaborator = null;
        },
        addCollaborator(collab) {
            this.$store.dispatch('addPendingCollaborator', {
                project: this.project,
                collaborator: collab,
                inviter: this.user.uid
            });
        },
        removeCollaborator(collabID) {
            this.$store.dispatch('removeCollaborator', {
                project: this.project,
                collaboratorID: collabID
            });
            // this.$refs.collaboratorsNav.open();
        },
        removePendingCollaborator(collabID) {
            this.$store.dispatch('removePendingCollaborator', {
                project: this.project,
                pendingCollaboratorID: collabID
            });
            // this.$refs.collaboratorsNav.open();
        }
    },
    created: function() {
        NavBus.$on('collaborators-nav.open', () => {
            if (this.$refs.collaboratorsNav) {
                this.$refs.collaboratorsNav.open();
            }
        });
    },
    components: {
        collaborator: CollaboratorsCollaborator,
        pendingCollaborator: CollaboratorsPendingCollaborator,
        invite: CollaboratorsInvite
    }
};
export default CollaboratorsNav;

</script>

<style lang="scss">
.heading-align {
    form {
        width: 100%;
        text-align: right;
    }
}
.collaboratorsNav {
    .md-subheader {
        font-size: 18px;
        color: #333;
        &.md-theme-show-mode {
            color: rgba(255, 255, 255, 0.87);
        }
    }
}
.pendingCollaboratorList {
    .md-list-item {
        background-color: lighten(#5ecfdf, 30%);
        .md-list-item-container {
            background-color: lighten(#5ecfdf, 30%) !important;
        }
    }
}
.collaboratorsNav {
    .md-title {
        font-weight: 700;
    }
    .md-subheader {
        font-weight: 100;
    }
}
</style>


// WEBPACK FOOTER //
// nav.vue?1c8f9690